"use strict";
/**
 * Shift Checklist — shared building-block types
 *
 * Reusable shapes referenced by the endpoint responses. Dates are ISO 8601
 * strings on the wire.
 *
 * Model (GH#454): status is tracked per `(branch, day, activity)` — the matrix.
 * There is no per-person "run"/"completion"; multiple people who did the same
 * task on the same day are merged into a single row's `doneBy` list.
 */
Object.defineProperty(exports, "__esModule", { value: true });
